import axios from "axios";
const API = process.env.NODE_ENV == "development" ? "https://192.168.112.114/posapi" : "https://service.elektroniskaskartes.lv/posapi";
//axios.defaults.withCredentials = true;

//axios.defaults.headers.common['Remote-Identity'] = "AUTH_TOKEN9876876";
const posapi = axios.create({
    crossDomain: true,
    withCredentials: true,
    baseURL: API,
});

const api = {
    api: API,
    resources: "https://elektroniskaskartes.lv/resources/",
    link(bin, img) {
        return API + "/auth/cms/bins/wallet/img/" + bin + "?img=" + img;
    },
    getTokenInfo(data) {
        return this.apiPostRequest("auth/cms/wpusers/token/info", data);
    },
    getToken(id) {
        return this.apiGetRequest("auth/cms/wpusers/token/" + id);
    },
    getEvents(data) {
        return this.apiPostRequest("auth/cms/events/select", data);
    },
    getActivities(data) {
        return this.apiPostRequest("auth/cms/activity/select", data);
    },
    sendPushNotification(idx) {
        return this.apiPostRequest("auth/cms/walletcards/notify/" + idx);
    },
    getWalletDevices(data) {
        return this.apiPostRequest("auth/cms/walletcards/select", data);
    },

    getWebPosUsers() {
        return this.apiGetRequest("auth/cms/wpusers/select");
    },
    deleteWebPosUser(id) {
        return this.apiPostRequest("auth/cms/wpusers/delete/" + id);
    },
    insertWebPosUser(data) {
        return this.apiPostRequest("auth/cms/wpusers/insert", data);
    },
    updateWebPosUser(data) {
        return this.apiPostRequest("auth/cms/wpusers/update/" + data.idx, data);
    },
    wpuCheckSettings(idx) {
        return this.apiPostRequest("auth/cms/wpusers/check/" + idx);
    },
    cleanRemoteIdentity(idx){
        return this.apiPostRequest("auth/cms/wpusers/clear/remid/" + idx);
    },

    getUsers() {
        return this.apiGetRequest("auth/cms/users/select");
    },
    deleteUser(id) {
        return this.apiPostRequest("auth/cms/users/delete/" + id);
    },
    insertUser(data) {
        return this.apiPostRequest("auth/cms/users/insert", data);
    },
    updateUser(data) {
        return this.apiPostRequest("auth/cms/users/update/" + data.idx, data);
    },

    getPosUsers() {
        return this.apiGetRequest("auth/cms/posusers/select");
    },
    loadTerminalBinTable(t, d) {
        return this.apiPostRequest("auth/cms/posusers/bintable", {
            terminal: t,
            domen: d
        });
    },
    checkMobilePosSettings(id) {
        return this.apiGetRequest("auth/cms/posusers/check/" + id);
    },
    deletePosUser(id) {
        return this.apiPostRequest("auth/cms/posusers/delete/" + id);
    },
    insertPosUser(data) {
        return this.apiPostRequest("auth/cms/posusers/insert", data);
    },
    updatePosUser(data) {
        return this.apiPostRequest("auth/cms/posusers/update/" + data.idx, data);
    },
    clearDevicePosUser(data) {
        return this.apiPostRequest("auth/cms/posusers/cleardev/" + data.item.idx, null, {
            token: data.token
        });
    },

    getTerminals() {
        return this.apiGetRequest("auth/cms/terminals/select");
    },
    deleteTerminal(id) {
        return this.apiPostRequest("auth/cms/terminals/delete/" + id);
    },
    insertTerminal(data) {
        return this.apiMultipartPostRequest("auth/cms/terminals/upsert", data.item, data.file);
    },
    updateTerminal(data) {
        return this.apiMultipartPostRequest("auth/cms/terminals/upsert", data.item, data.file);
    },

    getMerchants() {
        return this.apiGetRequest("auth/cms/merchants/select");
    },
    deleteMerchant(id) {
        return this.apiPostRequest("auth/cms/merchants/delete/" + id);
    },
    insertMerchant(data) {
        return this.apiPostRequest("auth/cms/merchants/insert", data);
    },
    updateMerchant(data) {
        return this.apiPostRequest("auth/cms/merchants/update/" + data.idx, data);
    },
    // MERCHANT CARDS
    getMerchantCards() {
        return this.apiGetRequest("auth/cms/merchants/cards/select");
    },
    addMerchantCards(id, data) {
        return this.apiPostRequest("auth/cms/merchants/cards/import/" + id, data);
    },
    deleteMerchantCard(id) {
        return this.apiPostRequest("auth/cms/merchants/card/delete/" + id);
    },
    freeMerchantCard(id) {
        return this.apiPostRequest("auth/cms/merchants/card/free/" + id);
    },
    insertMerchantCard(data) {
        return this.apiPostRequest("auth/cms/merchants/card/insert", data);
    },
    updateMerchantCard(data) {
        return this.apiPostRequest("auth/cms/merchants/card/update/" + data.idx, data);
    },
    // TRANSACTIONS
    getTransactions() {
        return this.apiGetRequest("auth/cms/transactions/select");
    },
    manualAcceptTransaction(id) {
        return this.apiPostRequest("auth/cms/transactions/delete/" + id);
    },

    // FILIALS
    getFilials() {
        return this.apiGetRequest("auth/cms/filials/select");
    },
    deleteFilial(id) {
        return this.apiPostRequest("auth/cms/filials/delete/" + id);
    },
    insertFilial(data) {
        return this.apiPostRequest("auth/cms/filials/insert", data);
    },
    updateFilial(data) {
        return this.apiPostRequest("auth/cms/filials/update/" + data.idx, data);
    },

    getBins() {
        return this.apiGetRequest("auth/cms/bins/select");
    },
    deleteBin(id) {
        return this.apiPostRequest("auth/cms/bins/delete/" + id);
    },
    insertBin(data) {
        return this.apiPostRequest("auth/cms/bins/insert", data);
    },
    updateBin(data) {
        return this.apiPostRequest("auth/cms/bins/update/" + data.bin, data);
    },
    getCodesForCard(bin, card, frame) {
        return this.apiPostRequest("auth/cms/bins/cardcodes/" + bin, {
            card: card,
            frame: frame == null ? null : frame.code,
            ft: frame == null ? null : frame.format
        })
    },
    getTemplateSource(bin) {
        return this.apiGetRequest("auth/cms/bins/pdfget/" + bin);
    },
    getWalletTemplateSource(bin) {
        return this.apiGetRequest("auth/cms/bins/walletget/" + bin);
    },
    setWalletTemplateSource(bin, json) {
        return this.apiPostRequest("auth/cms/bins/walletset/" + bin, json);
    },
    setPdfTemplateSource(bin, html) {
        return this.apiPostRequest("auth/cms/bins/pdfset/" + bin, html);
    },
    uploadBinTemplate(data) {
        return this.apiMultipartPostRequest("auth/cms/bin/template", data.item, data.file);
    },

    getLss() {
        return this.apiGetRequest("auth/cms/lss/select");
    },
    deleteLss(id) {
        return this.apiPostRequest("auth/cms/lss/delete/" + id);
    },
    insertLss(data) {
        return this.apiMultipartPostRequest("auth/cms/lss/upsert", data.item, data.file);
    },
    updateLss(data) {
        return this.apiMultipartPostRequest("auth/cms/lss/upsert", data.item, data.file);
    },

    addCodes(bin, json) {
        return this.apiPostRequest("auth/cms/bins/codes/" + bin, json);
    },

    loadWalletImages(bin, file) {
        return this.apiMultipartManyPostRequest("auth/cms/bins/wallet/img/upload/" + bin, null, file);
    },

    //LOGS
    getServerLog(file) {
        return this.apiGetRequest("auth/cms/log/load", {
            file: file
        });
    },
    loadLogsFiles() {
        return this.apiGetRequest("auth/cms/log/files");
    },

    //PKPASS merchants
    loadPkpassDirs() {
        return this.apiGetRequest("auth/cms/merchants/dirs");
    },
    pkpassCopy(from, to) {
        return this.apiPostRequest("auth/cms/merchants/alias/copy", {
            from: from,
            to: to
        });
    },

    pkpassImgLink(alias, img) {
        return API + "/auth/cms/merchants/pkpass/img/get/" + alias + "?img=" + img;
    },
    savePkpassImage(alias, file) {
        return this.apiMultipartManyPostRequest("auth/cms/merchants/pkpass/img/set/" + alias, null, file);
    },
    getPkpassTemplate(alias) {
        return this.apiGetRequest("auth/cms/merchants/pkpass/template/get/" + alias);
    },
    setPkpassTemplate(alias, data) {
        return this.apiPostRequest("auth/cms/merchants/pkpass/template/set/" + alias, data);
    },

    // ekk frames
    loadEkkFrames() {
        return this.apiGetRequest("auth/cms/ekkframes");
    },
    ping() {
        return new Promise((resolve, reject) => {
            this.apiGetRequest("ping", {
                u: true
            }).then(response => {
                this.$vm.$store.commit("user/setUser", response.user)
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    login(data) {
        return this.apiPostRequest("login", data);
    },
    logout() {
        return this.apiPostRequest("logout");
    },
    apiMultipartManyPostRequest(uri, data, file, pars) {
        if (typeof pars == "undefined" || pars == null) pars = {};
        if (typeof data == "undefined") data = null;
        let formdata = new FormData();
        formdata.append("data", JSON.stringify(data));
        if (file) {
            for (let k in file) {
                formdata.append("file", file[k], k);
            }
        }
        pars.prevcache = new Date().getTime();
        return new Promise((resolve, reject) => {
            posapi.post(uri, formdata, {
                params: pars,
                withCredentials: true,
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                let m = error;
                if (error.response && error.response.data) m = error.response.data;
                this.$vm.$root.$emit("showmsg", {
                    msg: m,
                    color: "error"
                });
                reject(error);
            });
        })
    },
    apiMultipartPostRequest(uri, data, file, pars) {
        if (typeof pars == "undefined" || pars == null) pars = {};
        if (typeof data == "undefined") data = null;
        let formdata = new FormData();
        formdata.append("data", encodeURIComponent(JSON.stringify(data)));
        if (file) {
            formdata.append("file", file);
        }
        pars.prevcache = new Date().getTime();
        return new Promise((resolve, reject) => {
            posapi.post(uri, formdata, {
                params: pars,
                withCredentials: true,
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                let m = error;
                if (error.response.data) m = error.response.data;
                this.$vm.$root.$emit("showmsg", {
                    msg: m,
                    color: "error"
                });
                reject(error);
            });
        })
    },
    apiPostRequest(uri, data, pars) {
        if (typeof pars == "undefined" || pars == null) pars = {};
        if (typeof data == "undefined") data = null;
        pars.prevcache = new Date().getTime();
        return new Promise((resolve, reject) => {
            posapi.post(uri, data, {
                params: pars,
                withCredentials: true,
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                let m = error;
                if (error.response && error.response.data) m = error.response.data;
                this.$vm.$root.$emit("showmsg", {
                    msg: m,
                    color: "error"
                });
                reject(error);
            });
        })
    },
    apiGetRequest(uri, pars) {
        if (typeof pars == "undefined" || pars == null) pars = {};
        pars.prevcache = new Date().getTime();
        return new Promise((resolve, reject) => {
            posapi.get(uri, {
                params: pars,
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                this.$vm.$store.commit("user/clearUser")
                this.$vm.$router.push("/login")
                let m = error;
                if (error.response && error.response.data) m = error.response.data;
                this.$vm.$root.$emit("showmsg", {
                    msg: m,
                    color: "error"
                });
                reject(error);
            });
        })
    },

    copyText(el) {
        try {
            let range = document.createRange();
            range.selectNode(document.getElementById(el));
            console.log(range);
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges(); // to deselect
        } catch (error) {
            console.log(error);
        }

    },

    upper_menu: [{
            text: "users",
            route: "/users",
            side: true,
            icon: "mdi-account-multiple"
        },
        {
            text: "transactions",
            route: "/transactions",
            side: true,
            icon: "mdi-handshake-outline"
        },
        {
            text: "mobile",
            route: "/mobile",
            icon: "mdi-cellphone-android"
        },
        {
            text: "wpusers",
            route: "/wpusers",
            icon: "mdi-web"
        },
         {
             text: "merchants",
             route: "/merchants",
             icon: "mdi-store"
         },
        {
            text: "divider",
            divider: true
        },
        {
            text: "activities",
            route: "/activities",
            icon: "mdi-cash-register"
        },
        {
            text: "logs",
            route: "/logs",
            icon: "mdi-notebook"
        },
        {
            text: "events",
            route: "/events",
            icon: "mdi-notebook-outline"
        },
    ],
    getSavedLocaleAsStr() {
        return localStorage.getItem("lang");
    },
    setLocale(v) {
        localStorage.setItem("lang", v);
        this.$vm.$i18n.locale = v;
    },
    setVm(vm) {
        this.$vm = vm;
        this.$vm.$i18n.locale = this.getSavedLocaleAsStr();
    },
}
export default api;